//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CIdentify',

  props: {
    value: { type: String },

    fontSizeMin: {
      type: Number,
      default: 14,
    },

    fontSizeMax: {
      type: Number,
      default: 26,
    },

    backgroundColorMin: {
      type: Number,
      default: 180,
    },

    backgroundColorMax: {
      type: Number,
      default: 240,
    },

    colorMin: {
      type: Number,
      default: 50,
    },

    colorMax: {
      type: Number,
      default: 160,
    },

    lineColorMin: {
      type: Number,
      default: 40,
    },

    lineColorMax: {
      type: Number,
      default: 180,
    },

    dotColorMin: {
      type: Number,
      default: 0,
    },

    dotColorMax: {
      type: Number,
      default: 255,
    },

    contentWidth: {
      type: Number,
      default: 112,
    },

    contentHeight: {
      type: Number,
      default: 28,
    },
  },

  data () {
    return {
      identifyCode: '',
      identifyCodes: '1234567890',
    }
  },

  watch: {
    identifyCode (val) {
      this.$emit('input', val)
    },
  },

  mounted () {
    this.refreshCode()
  },

  methods: {
    // 生成一个随机数
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },

    // 生成一个随机的颜色
    randomColor (min, max) {
      const r = this.randomNum(min, max)
      const g = this.randomNum(min, max)
      const b = this.randomNum(min, max)

      return `rgb(${r},${g},${b})`
    },

    drawPic () {
      const canvas = document.getElementById('s-canvas')
      const ctx = canvas.getContext('2d')
      ctx.textBaseline = 'bottom'

      // 绘制背景
      // ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax)
      ctx.fillStyle = '#567afc'

      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)

      // 绘制文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawText(ctx, this.identifyCode[i], i)
      }

      // this.drawDot(ctx)
    },

    refreshCode () {
      this.identifyCode = ''

      this.makeCode(this.identifyCodes, 4)
      this.drawPic()
    },

    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },

    drawText (ctx, txt, i) {
      // ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax)
      ctx.fillStyle = '#fff'
      ctx.font = `${this.randomNum(this.fontSizeMin, this.fontSizeMax)}px SimHei`
      const x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1))
      const y = this.randomNum(this.fontSizeMax, this.contentHeight - 5)

      // 修改坐标原点和旋转角度
      ctx.translate(x, y)
      ctx.fillText(txt, 0, 0)

      // 恢复坐标原点和旋转角度
      ctx.translate(-x, -y)
    },

    // drawDot (ctx) {
    //   // 绘制干扰点
    //   for (let i = 0; i < 50; i++) {
    //     ctx.fillStyle = this.randomColor(0, 255)

    //     ctx.beginPath()
    //     ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI)
    //     ctx.fill()
    //   }
    // },
  },
}
